import React, {useState} from "react";
import { PortalFormItemSelectDocType } from "./FormUtils";
import { useQuery } from "@apollo/client";
import { getDocumentType } from "../pages/documents/__generated__/getDocumentType";
import { SELECT_ALL_DOCTYPE_QUERY, SELECT_PROVIDER_DOCTYPE_QUERY } from "../pages/documents/queries";
import { useIntl, WrappedComponentProps } from "react-intl";
import { getI18n } from "../utils/Utils";
import { getAllDocumentTypes } from "../pages/documents/__generated__/getAllDocumentTypes";
import { getProviderDocumentType } from "../pages/documents/__generated__/getProviderDocumentType";
import { useLocation } from "react-router-dom";
import { useAppSelector  } from "../main/hooks"

export type IAppComponentProps = 
{ currentUser?: any; 
  distinctEntitlements?: string[];
  bmwTypesOnly?: boolean;
} & WrappedComponentProps;

export const DocumentType: React.FunctionComponent<IAppComponentProps> = (props) => {
  const intl = useIntl();
  const documentType: getDocumentType = { getDocumentType: [] };
  const documentTypeList = [];

  const docOverviewFiltersState = useAppSelector((state) => state.documentOverview);
  const location = useLocation();
  const isFromCaptureDocument = location.state && location.state.isFromCaptureDocument;

  const [documentTypeSelectedValue, setDocumentTypeSelectedValue] = useState(isFromCaptureDocument ?
     docOverviewFiltersState.documentOverviewFilters.documentTypeId: null);

  const append = (serviceProviderId) => {
    if (serviceProviderId === 1)
    {
      return " - ECAP";
    }
    return "";
  }

  const { data } = useQuery<getAllDocumentTypes>(SELECT_ALL_DOCTYPE_QUERY,
    {
      fetchPolicy: "cache-first"
    }
  );

     //Get only BMW Document types (serviceProviderId = 1)
     const { data: partialData } = useQuery<getProviderDocumentType>(
      SELECT_PROVIDER_DOCTYPE_QUERY,
      {
          fetchPolicy: 'cache-first',
          variables: { serviceProviderId: 1 },
          onError: (error) => console.error(error)
      }
  );

  if (!props.bmwTypesOnly)
  {
    if (data?.getAllDocumentTypes) {
      data.getAllDocumentTypes.forEach(item => {
        documentTypeList.push({ ...item, documentType: getI18n(item.phraseId, item.documentType, intl).concat(append(item.serviceProviderId)) });
      });
      documentType.getDocumentType = documentTypeList;
    }
  }
  else
  {
    if (partialData?.getProviderDocumentType) {
      partialData.getProviderDocumentType.forEach(item => {
        documentTypeList.push({ ...item, documentType: getI18n(item.phraseId, item.documentType, intl)});
      });
      documentType.getDocumentType = documentTypeList;
    }
  }

  return (
    <>
      <PortalFormItemSelectDocType
        type={"single"}
        label={intl.formatMessage({ id: "welcome-document-type", defaultMessage: "Document Type" })}
        name={"documentTypeId"}
        placeHolder={intl.formatMessage({
          id: "welcome-document-type",
          defaultMessage: "Document Type"
        })}
        getDocumentType={documentType} colSpan={5}
        defaultValue={isFromCaptureDocument ? docOverviewFiltersState.documentOverviewFilters.documentTypeId :null} 
        value={documentTypeSelectedValue}
        onChange={(value) => setDocumentTypeSelectedValue(value)}
        
        />
    </>
  );
};